import axios from "axios";

const api = axios.create({
  // baseURL: "http://localhost:8080/api",
  // baseURL: "http://200.208.73.149:8099/api",
  baseURL: "http://54.172.77.228:8080/api",
});

export default api;
